module.exports = __webpack_public_path__ + "img/AR.3036121f.svg";